import React from 'react';
import { ToggleSwitch } from '../../../sdk';

/**
 * Stats editor - array of label/value pairs
 */
export function StatsEditor({ stats, onChange, children }) {
  const hasStats = stats && stats.length > 0;
  
  const handleToggle = (enabled) => {
    if (enabled) {
      onChange([
        { label: 'Goal', value: '€100k' },
        { label: 'Land', value: '10-20 ha' },
        { label: 'Stage', value: 'Pre-launch' },
      ]);
    } else {
      onChange([]);
    }
  };

  const updateStat = (index, field, value) => {
    const updated = [...stats];
    updated[index] = { ...updated[index], [field]: value };
    onChange(updated);
  };

  const addStat = () => {
    if (stats.length < 4) {
      onChange([...stats, { label: '', value: '' }]);
    }
  };

  const removeStat = (index) => {
    onChange(stats.filter((_, i) => i !== index));
  };

  return (
    <div className="field-container">
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="module-header">Stats</div>
          <div className="module-desc">Key metrics (up to 4).</div>
        </div>
        <ToggleSwitch
          checked={hasStats}
          onChange={(checked) => handleToggle(checked)}
          size="sm"
        />
      </div>

      {hasStats && (
        <div className="mt-3 space-y-2">
          {stats.map((stat, i) => (
            <div key={i} className="flex items-center gap-2">
              <input
                value={stat.label || ''}
                onChange={(e) => updateStat(i, 'label', e.target.value)}
                className="input-base flex-1"
                placeholder="Label"
              />
              <input
                value={stat.value || ''}
                onChange={(e) => updateStat(i, 'value', e.target.value)}
                className="input-base flex-1"
                placeholder="Value"
              />
              <button
                onClick={() => removeStat(i)}
                className="icon-btn"
              >
                ×
              </button>
            </div>
          ))}
          {stats.length < 4 && (
            <button
              onClick={addStat}
              className="btn-control w-full"
            >
              + Add Stat
            </button>
          )}
        </div>
      )}
      {hasStats && children}
    </div>
  );
}
